import Cookies from 'js-cookie'
import uniq from '../utils/uniq'

const PREFIX = 'KRSO_'

function valueToArray(value) {
  if (!value) return []
  return value.split(',')
}

function read(key) {
  return Cookies.get(`${PREFIX}${key}`)
}

const threeHours = 1 / 8
const isSsh = !['local', 'dev', 'e2e'].includes(process.env.VUE_APP_MODE)

function save(key, value, option = {}) {
  Cookies.set(`${PREFIX}${key}`, value, {
    expires: threeHours,
    secure: isSsh,
    sameSite: 'strict',
    ...option,
  })
}

function remove(key) {
  Cookies.remove(`${PREFIX}${key}`)
}

export function readRecommends() {
  const cookie = read('recommends')
  return valueToArray(cookie)
}

export function saveRecommends(array) {
  const saveText = array.join(',')
  if (saveText) {
    save('recommends', saveText)
  } else {
    remove('recommends')
  }
}

export function mergeRecommends(id) {
  const savedRecommends = readRecommends()
  const updatedRecommends = uniq([id.toString()].concat(savedRecommends))
  saveRecommends(updatedRecommends)
}

export function saveToken(token) {
  save('token', token)
}

export function readToken() {
  return read('token')
}

export function removeToken() {
  remove('token')
}
